import '@loyal_template/password.css'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import Helmet from 'react-helmet'
import { Link } from 'react-router-dom'
import FormPlaceholder from './FormPlaceholder'
import ReactPlaceholder from 'react-placeholder'
import yn from 'yn'
import { Alert } from 'loyal-react'

class SecurityAccess extends Component {
  state = {
    hasUraPassword: false,
    lockedUraPassword: false,
    formReady: false,
    error: null
  }

  componentDidMount = () => {
    this.checkHasUraPassword()
  }

  checkHasUraPassword = () => {
    const handleSuccess = response => {
      if (response && response.type === 'FETCH_HAS_URA_PASS_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        if (data) {
          this.setState({ hasUraPassword: true })
          this.getSonarStatus()
        } else {
          this.setState({ hasUraPassword: false })
        }
      } else {
        this.setState({
          error: { msg: 'ERRO' }
        })
      }
      this.setState({ formReady: true })
    }

    const handleError = () => {
      this.setState({
        error: { msg: 'ERRO' },
        formReady: true
      })
    }
    const cpfEncoded = Buffer.from(this.props.userInfo.username).toString('base64')
    this.props
      .fetchHasUraPass(cpfEncoded)
      .then(handleSuccess)
      .catch(handleError)
  }

  getSonarStatus = () => {
    const handleSuccess = response => {
      if (response && response.type === 'FETCH_GET_SONAR_STATUS_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        this.setState({ lockedUraPassword: !data.isUserEnabled })
      }
      this.setState({ formReady: true })
    }

    const handleError = () => {
      this.setState({ formReady: true })
    }

    this.props
      .fetchSonarStatus()
      .then(handleSuccess)
      .catch(handleError)
  }

  closeAlert = () => this.setState({ error: null, success: null })

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Minha senha - ${process.env.REACT_APP_TITLE || ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container py-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='col-12 col-lg-8 mt-0'>
                {this.state.error && this.state.error !== null ? (
                  <Alert
                    isError
                    title={this.state.error.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />
                ) : (
                  ''
                )}
                <div className='row'>
                  <div className='col-12 border-color-ui-3 bg-white border radius'>
                    <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
                      <div className='col mr-auto'>
                        <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
                          Acesso e segurança
                        </h1>
                      </div>
                    </div>
                    <ReactPlaceholder
                      ready={this.state.formReady}
                      customPlaceholder={<FormPlaceholder />}
                    >
                      <div className='col-12 border-color-ui-3 d-none'>
                        <div className='d-flex mt-2 align-items-center'>
                          <i
                            className='icon icon_message mr-2 color-brand-1'
                            aria-hidden='true'
                          />
                          <div className='flex-column'>
                            <span className='txt-left txt-font-body txt-body-sm color-ui-2'>
                              E-mail
                            </span>
                            <br />
                            <strong className='txt-font-body txt-initial color-title txt-email-flow'>
                              {this.props.email.value}
                            </strong>
                          </div>
                          <div className='col btn-flat btn-sm txt-right d-none d-md-block txt-font-body'>
                            <Link
                              to='/token-change-email'
                              className='color-brand-2 txt-underline'
                            >
                              Alterar
                            </Link>
                          </div>
                        </div>
                        <div className='col-12 btn-flat btn-sm d-block d-md-none txt-font-body pb-0 pl-5'>
                          <Link
                            to='/token-change-email'
                            className='color-brand-2 txt-underline'
                          >
                            Alterar
                          </Link>
                        </div>
                      </div>
                      <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3 d-none' />
                      <div className='col-12 border-color-ui-3'>
                        <div className='d-flex mt-2 align-items-center'>
                          <i
                            className='icon icon_headphone mr-2 color-brand-1'
                            aria-hidden='true'
                          />
                          <div className='flex-column'>
                            <span className='txt-left txt-font-body txt-body-sm color-ui-2'>
                              Senha da central de atendimento
                            </span>
                            <br />
                            <strong className='txt-font-body txt-initial color-title txt-email-flow w-100 mt-1'>
                              {yn(this.state.lockedUraPassword) ? (
                                <span className='locked-pill px-2 py-half pos-relative t-1'>
                                  Senha bloqueada
                                </span>
                              ) : !yn(this.state.hasUraPassword) ? (
                                <span className='not-registered-pill px-2 py-half pos-relative t-1'>
                                  Você não possui uma senha cadastrada
                                </span>
                              ) : (
                                '******'
                              )}
                            </strong>
                          </div>
                          <div className='col btn-flat btn-sm txt-right d-none d-md-block txt-font-body'>
                            {yn(this.state.lockedUraPassword) ? (
                              <Link
                                to='/unlock-ura-password'
                                className='color-brand-2 txt-underline'
                              >
                                Desbloquear
                              </Link>
                            ) : !yn(this.state.hasUraPassword) ? (
                              <Link
                                to='/create-ura-password'
                                className='color-brand-2 txt-underline'
                              >
                                Cadastrar senha numérica
                              </Link>
                            ) : (
                              <Link
                                to='/change-ura-password'
                                className='color-brand-2 txt-underline'
                              >
                                Alterar
                              </Link>
                            )}
                          </div>
                        </div>
                        <div className='col-12 btn-flat btn-sm d-block d-md-none txt-font-body pb-0 pl-5'>
                          {yn(this.state.lockedUraPassword) ? (
                            <Link
                              to='/unlock-ura-password'
                              className='color-brand-2 txt-underline'
                            >
                              Desbloquear
                            </Link>
                          ) : !yn(this.state.hasUraPassword) ? (
                            <Link
                              to='/create-ura-password'
                              className='color-brand-2 txt-underline'
                            >
                              Cadastrar senha numérica
                            </Link>
                          ) : (
                            <Link
                              to='/change-ura-password'
                              className='color-brand-2 txt-underline'
                            >
                              Alterar
                            </Link>
                          )}
                        </div>
                      </div>
                      <div className='row px-0 pb-2 pt-half border-bottom border-color-ui-3' />
                      <div className='col-12 border-color-ui-3'>
                        <div className='d-flex mt-2 align-items-center'>
                          <i
                            className='icon icon_password mr-2 color-brand-1'
                            aria-hidden='true'
                          />
                          <div className='flex-column'>
                            <span className='txt-left txt-font-body txt-body-sm color-ui-2'>
                              Senha
                            </span>
                            <br />
                            <strong className='txt-font-body txt-initial color-title'>
                              ******
                            </strong>
                          </div>
                          <div className='col btn-flat btn-sm txt-right d-none d-md-block txt-font-body'>
                            <Link
                              to='/my-account/change-password'
                              className='color-brand-2 txt-underline'
                            >
                              Alterar
                            </Link>
                          </div>
                        </div>
                        <div className='col-12 btn-flat btn-sm d-block d-md-none txt-font-body pb-0 pl-5'>
                          <Link
                            to='/my-account/change-password'
                            className='color-brand-2 txt-underline'
                          >
                            Alterar
                          </Link>
                        </div>
                      </div>
                      <div className='row px-0 pb-2 pt-half border-color-ui-3' />
                    </ReactPlaceholder>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

SecurityAccess.propTypes = {
  location: PropTypes.object.isRequired,
  email: PropTypes.object,
  userInfo: PropTypes.object,
  fetchHasUraPass: PropTypes.func.isRequired,
  fetchSonarStatus: PropTypes.func.isRequired
}

export default SecurityAccess



// WEBPACK FOOTER //
// ./src/Participant/SecurityAccess/SecurityAccess.js